import { initializeApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getAnalytics, isSupported } from "firebase/analytics";
import type { Analytics } from "firebase/analytics";
import {testFirebaseConfig, prodFirebaseConfig} from './firebaseConfig'
import config from '../config';


var appStage = config?.env;
const isCraDevServer = process.env.NODE_ENV === 'development';
/** Match API URL rules in config.ts: CRA dev server always uses test Firebase even when REACT_APP_NODE_ENV=prod. */
export const activeFirebaseConfig =
  appStage === 'prod' && !isCraDevServer ? prodFirebaseConfig : testFirebaseConfig;
const firebaseConfig = activeFirebaseConfig;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase Analytics is not available in all environments (e.g. during Jest tests
// or in browsers where IndexedDB is unavailable). Attempt to initialise
// Analytics only when it is actually supported. This prevents the runtime
// warning:
//   @firebase/analytics: Analytics: IndexedDB unavailable or restricted in this environment.
// We expose a (possibly undefined) `analytics` export so that production code
// can still import it safely.

export let analytics: Analytics | undefined;

// Only attempt to initialise analytics in browser-like environments.
if (typeof window !== "undefined") {
  // `isSupported` returns a promise resolving to `true` when the Analytics
  // SDK can be used in the current runtime. We defer the initialisation until
  // support is confirmed.
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    // Swallow any errors because analytics is non-critical.
    .catch(() => undefined);
}

// Lazy-initialize Auth so the app can load even if the API key is invalid or restricted.
// getAuth(app) is only called when auth is first used (e.g. sign-in), avoiding a crash at load.
let _auth: Auth | null = null;
function getAuthInstance(): Auth {
  if (_auth) return _auth;
  _auth = getAuth(app);
  return _auth;
}
export const auth = new Proxy({} as Auth, {
  get(_, prop) {
    return (getAuthInstance() as unknown as Record<string, unknown>)[prop as string];
  },
});